module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pageHeader"
  }, [_c('div', {
    staticClass: "nav-right"
  }, [_c('el-dropdown', {
    attrs: {
      "trigger": "click"
    },
    on: {
      "command": _vm.handleCommand
    }
  }, [_c('span', {
    staticClass: "el-dropdown-link"
  }, [_vm._v(_vm._s(_vm.userInfo.realname || _vm.userInfo.username)), _c('i', {
    staticClass: "el-icon-caret-bottom el-icon--right"
  })]), _vm._v(" "), _c('el-dropdown-menu', {
    staticClass: "header",
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [(_vm.appInfo && !_vm.userInfo.sso) ? _c('el-dropdown-item', {
    attrs: {
      "command": "changePwd"
    }
  }, [_vm._v(_vm._s(_vm.$t('headBar.change_pwd')))]) : _vm._e(), _vm._v(" "), _c('el-dropdown-item', {
    attrs: {
      "command": "logout"
    }
  }, [_vm._v(_vm._s(_vm.$t('headBar.logout')))])], 1)], 1), _vm._v(" "), _c('el-dropdown', {
    attrs: {
      "trigger": "click"
    },
    on: {
      "command": _vm.changeEvent
    }
  }, [_c('span', {
    staticClass: "el-dropdown-link"
  }, [_vm._v(_vm._s(_vm.$t('headBar.lang'))), _c('i', {
    staticClass: "el-icon-caret-bottom el-icon--right"
  })]), _vm._v(" "), _c('el-dropdown-menu', {
    staticClass: "header",
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('el-dropdown-item', {
    attrs: {
      "command": "en"
    }
  }, [_vm._v(_vm._s(_vm.$t('headBar.en')))]), _vm._v(" "), _c('el-dropdown-item', {
    attrs: {
      "command": "cn"
    }
  }, [_vm._v(_vm._s(_vm.$t('headBar.cn')))])], 1)], 1)], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-5e0b3592", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5e0b3592"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/layouts/header.vue
// module id = 595
// module chunks = 21